"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConnectedWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = require("styled-components");
var _styles = require("@material-ui/styles");
var _reactI18next = require("react-i18next");
var _jss = require("jss");
var _appSagas = _interopRequireDefault(require("./store/appSagas"));
var _appReducer = _interopRequireDefault(require("./store/appReducer"));
var _App = _interopRequireDefault(require("./components/App"));
var _PropsContext = require("./context/PropsContext");
var _services = require("./services");
var _i18n = _interopRequireDefault(require("./i18n"));
var _globals = _interopRequireDefault(require("./components/vfuk/globals"));
var _useGuidedSellingStatus = require("./hooks/app/useGuidedSellingStatus");
var _useAppDispatch = require("./hooks/useAppDispatch");
var _useWindowAPI = _interopRequireDefault(require("./hooks/app/useWindowAPI"));
var _widgetUtils = require("./utils/widgetUtils");
var _themes = _interopRequireDefault(require("./components/vfuk/themes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const WidgetContent = _ref => {
  let {
    themeWS10,
    __instanceId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: themeWS10
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.I18nextProvider, {
    i18n: _i18n.default
  }, /*#__PURE__*/_react.default.createElement(themeWS10.globalStyles, null), /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId
  })));
};
const Widget = props => {
  const {
    __instanceId,
    __pageId
  } = props;
  return /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: {
      __instanceId,
      __pageId
    }
  }, /*#__PURE__*/_react.default.createElement(WidgetWithPropsContext, props));
};
const WidgetWithPropsContext = props => {
  var _config$settings, _config$uiSettings;
  const {
    config,
    i18n,
    language,
    __instanceId,
    marketingId,
    addToCartCallback
  } = props;
  const {
    openGuidedSellingModal,
    closeGuidedSellingModal
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const {
    setFlags,
    setMetadata,
    setSkippedQuestionIds,
    resetQuestionnaire,
    setAdditionalSummaries
  } = (0, _useWindowAPI.default)();
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  if (!language || !config) {
    return null;
  }

  // setup language
  if (config.language && config.language !== language) {
    dispatch({
      type: 'LANGUAGE_REQUEST',
      payload: config.language
    });
    return null;
  }

  // setup services
  (0, _services.setupServices)({
    config,
    i18n,
    marketingId,
    addToCartCallback,
    closeGuidedSellingModal,
    openGuidedSellingModal,
    setFlags,
    setMetadata,
    setSkippedQuestionIds,
    resetQuestionnaire,
    setAdditionalSummaries
  });

  // ---- Delete slider dots styles ----
  if (config !== null && config !== void 0 && (_config$settings = config.settings) !== null && _config$settings !== void 0 && _config$settings.removeSliderDotStyles) {
    (0, _widgetUtils.deleteSliderDotsStyles)();
  }
  // ----

  // ---- Create the widget in shadow dom ----
  const shadowDomNodes = {};
  if (config.enableShadowDOM) {
    shadowDomNodes.styleSlot = (0, _widgetUtils.setupShadowDom)();
  }

  // setup assets
  const assetsPath = 'assets/ws10/';
  const ingressUrl = window.REACT_APP_GS_INGRESS_URL;
  const assetsLocation = ingressUrl ? `https://${ingressUrl}/${assetsPath}` : assetsPath;

  // overwrite theme colors
  const overwrittenThemeName = (_config$uiSettings = config.uiSettings) === null || _config$uiSettings === void 0 ? void 0 : _config$uiSettings.theme;
  if (overwrittenThemeName) {
    const overwrittenTheme = (0, _themes.default)(overwrittenThemeName);
    (0, _widgetUtils.setupOverwrittenTheme)(overwrittenTheme);
  }
  _r10SourceLibrary.themeWS10.globalStyles = _globals.default;
  _r10SourceLibrary.themeWS10.setBaseAssetLocation(assetsLocation);
  _r10SourceLibrary.themeWS10.setAssetLocations('fonts', 'fonts/');
  _r10SourceLibrary.themeWS10.setAssetLocations('icons', 'icons/');
  _r10SourceLibrary.themeWS10.setAssetLocations('logos', 'logos/');
  if (!shadowDomNodes.styleSlot) {
    return /*#__PURE__*/_react.default.createElement(WidgetContent, {
      themeWS10: _r10SourceLibrary.themeWS10,
      __instanceId: __instanceId
    });
  }

  // inject MUI styles
  const jss = (0, _jss.create)({
    ...(0, _styles.jssPreset)(),
    insertionPoint: shadowDomNodes.styleSlot
  });
  return /*#__PURE__*/_react.default.createElement(_styledComponents.StyleSheetManager, {
    target: shadowDomNodes.styleSlot
  }, /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
    jss: jss
  }, /*#__PURE__*/_react.default.createElement(WidgetContent, {
    themeWS10: _r10SourceLibrary.themeWS10,
    __instanceId: __instanceId
  })));
};
const mapStateToProps = state => ({
  language: state.language.language
});
const ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(Widget);
exports.ConnectedWidget = ConnectedWidget;
ConnectedWidget.reducer = _appReducer.default;
ConnectedWidget.sagas = _appSagas.default;
var _default = ConnectedWidget;
exports.default = _default;